import { OrganizationListPage } from "@/features/organization/pages/OrganizationList";

const OrganizationList = () => {
  return <OrganizationListPage />;
};

export default OrganizationList;
